module.exports = __webpack_public_path__ + "img/online_checkin.75f1ca8f.png";